import { AbsoluteFill, Sequence } from "remotion";
import { SCENE, BRAND } from "./constants";
import { Scene01Hook } from "./Scene01Hook";
import { Scene02Problem } from "./Scene02Problem";
import { Scene03Intuition } from "./Scene03Intuition";
import { Scene04Approach } from "./Scene04Approach";
import { Scene05Code1 } from "./Scene05Code1";
import { Scene06Code2 } from "./Scene06Code2";
import { Scene07Payoff } from "./Scene07Payoff";
import { Scene08Outro } from "./Scene08Outro";

export const EAKCMultiTenantRLS: React.FC = () => (
  <AbsoluteFill style={{ backgroundColor: BRAND.space0 }}>
    <Sequence from={SCENE.hook.start} durationInFrames={SCENE.hook.duration}>
      <Scene01Hook />
    </Sequence>
    <Sequence
      from={SCENE.problem.start}
      durationInFrames={SCENE.problem.duration}
    >
      <Scene02Problem />
    </Sequence>
    <Sequence
      from={SCENE.intuition.start}
      durationInFrames={SCENE.intuition.duration}
    >
      <Scene03Intuition />
    </Sequence>
    <Sequence
      from={SCENE.approach.start}
      durationInFrames={SCENE.approach.duration}
    >
      <Scene04Approach />
    </Sequence>
    <Sequence from={SCENE.code1.start} durationInFrames={SCENE.code1.duration}>
      <Scene05Code1 />
    </Sequence>
    <Sequence from={SCENE.code2.start} durationInFrames={SCENE.code2.duration}>
      <Scene06Code2 />
    </Sequence>
    <Sequence
      from={SCENE.payoff.start}
      durationInFrames={SCENE.payoff.duration}
    >
      <Scene07Payoff />
    </Sequence>
    <Sequence from={SCENE.outro.start} durationInFrames={SCENE.outro.duration}>
      <Scene08Outro />
    </Sequence>
    {/* <Audio src={...} /> — add a recorded VO track here later. */}
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
